<template>
  <div>
    <div v-if="global.selectedAppTab == 5">
      <nas-card :clientPortal="clientPortal" :fixedHeaders="false"></nas-card>
      <attribute-card :clientPortal="clientPortal"></attribute-card>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "@vue/composition-api";
import global from "@/composables/global";
import NasCard from "@/components/ClientPortal/NasCard";
import AttributeCard from "@/components/ClientPortal/AttributeCard";

export default defineComponent({
  components: {
    NasCard,
    AttributeCard,
  },
  props: {
    clientPortal: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      global,
    };
  },
});
</script>
